<template>
  <el-row style="margin-top: 20px;">
    <el-col :span="1.5" style="margin-left: 20px">发货单号：</el-col>
    <el-col :span="4" >{{ busData.ship_no }}</el-col>
    <el-col :span="1.5" >订单编号：</el-col>
    <el-col :span="4" >{{ busData.order_no }}</el-col>
    <el-col :span="1.5" style="margin-left: 25px">物流单号：</el-col>
    <el-col :span="4" >{{ busData.logistics_no }}</el-col>
    <el-col :span="1.5" >物流公司：</el-col>
    <el-col :span="4" >{{ busData.logistics_company }}</el-col>
  </el-row>

  <div style="height:50px;overflow-y: auto;overflow-x: hidden">
    <el-row class="row" >
      <el-col style="margin-right: 30px" :span="6">
        <el-input style="width: 370px;margin-left: 10px" v-model="busData.sn" placeholder="请扫SN码添加"
                  @change="addFormShipSn()" clearable :disabled="disabled"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button style="margin-left: 110px" @click="addShipSn()" :disabled="disabled">添加</el-button>
      </el-col>
      <el-col :span="1.5" style="margin-left: 73px">订单总数：</el-col>
      <el-col :span="3" >{{ busData.cnt }}</el-col>
      <el-col :span="2.5" style="margin-left: 13px">历史发货数量：</el-col>
      <el-col :span="2" >{{ busData.shipped_number }}</el-col>
    </el-row>
  </div>

  <div class="frameQuery">
    <frame-query ref="frameQuery" componentParam="rebuild_ship_sn_item"
                 :parent-data="{ship_id:busData.id}"></frame-query>
  </div>
</template>

<script>

import {nextTick} from "vue";

export default {
  inject: ['$fn'],
  name: "Ship",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      disabled:'',
      ship_id: '',
      busData:{
        shipped_status:''
      }
    }
  },
  created() {
    this.getShipDetail()
    this.getShippedStatus()
    },
  methods: {

    //获取基础数据
    async getShipDetail() {
      this.busData.id = this.parentData.id
      this.busData.ship_no = this.parentData.ship_no
      this.busData.order_id = this.parentData.order_id
      this.busData.logistics_no = this.parentData.logistics_no
      this.busData.logistics_company = this.parentData.logistics_company
      let params = {order_id:this.busData.order_id}
      let orderData = await this.$http('rebuildShipService.getOrderNoByOrderId', params)
      this.busData.order_no = orderData.order_no;
      this.busData.cnt = orderData.cnt;
      this.busData.shipped_number = orderData.shipped_number
    },

    //添加sn码
    async addFormShipSn(){
      var params = {
        order_id: this.busData.order_id,
        ship_id: this.busData.id,
        sn: this.busData.sn
      }
      await this.$http('rebuildShipService.addFormShipSn',params)
      this.busData.sn = ''
      await nextTick(() => {
        this.$refs.frameQuery.search();
      })
    },

    //button添加sn码
    async addShipSn(){
      this.busData.sn = ''
      await nextTick(() => {
        this.$refs.frameQuery.search();
      })
    },

    ////获取发货单发货状态
    async getShippedStatus(){
      this.busData.id = this.parentData.id
      let params = {ship_id:this.busData.id}
      let shipData = await this.$http('rebuildShipService.getShippedStatus', params)
      this.disabled = shipData.shipped_status;
    }
  }
}
</script>

<style scoped>

.row {
  margin-top: 15px;
  padding: 0;
}

.frameQuery {
  margin: 20px 0 0 0;
  box-shadow: 0 0 4px -2px rgba(0,0,0,5);
  padding-bottom: 10px;
}

</style>